import QuotePersistenceGate from '#client/App/Quote/QuotePersistenceGate';
import CartError from '#client/components/CartError';
import FlowConfigBase from '#client/config/FlowConfigBase';
import AUTH_POLICY from '#client/constants/authPolicy';
import * as ROUTES from '#client/constants/routes';

import PAGES, { PAGE_KEYS } from '../flowPageConfig';

export default FlowConfigBase.createEntry({
  id: 'quote',
  pageKeys: [PAGE_KEYS.CHECKOUT, PAGE_KEYS.CONCLUSION_QUOTE],
  pageConfigs: {
    [PAGES.CHECKOUT.pageComponent]: {
      pageComponentProps: {
        slotProps: {
          businessCardProps: {
            contactInfoFields: {
              firstName: { disabled: true },
              lastName: { disabled: true },
              email: { disabled: true },
              phone: { disabled: true }
            }
          }
        }
      }
    }
  },
  authRedirect: false,
  authPolicy: AUTH_POLICY.NOT_ALLOWED,
  entityType: 'llc', // TODO: we need to make this nullable to ensure it does not clobber the business info
  isPrimary: true,
  postOrderAutoLogin: true,
  disableCartCreation: true,
  disableLeadManager: true,
  postOrderRedirect: `${ROUTES.SHOP_QUOTE_CONCLUSION}`,
  priceListUuids: {
    development: null,
    production: null
  },
  persistenceGate: QuotePersistenceGate,
  errorBoundaryFallback: CartError
});
